import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

interface MarketingAnalyticsParams {
  startDate: string;
  endDate: string;
}

/**
 * Custom hook to fetch marketing analytics data
 * Used by Dashboard Funnel Summary and Marketing page
 */
export function useMarketingAnalytics(
  userId: string,
  params: MarketingAnalyticsParams
) {
  return useQuery({
    queryKey: ["marketing-analytics", userId, params.startDate, params.endDate],
    queryFn: () => api.getMarketingAnalytics(userId, params),
    enabled: !!userId && !!params.startDate && !!params.endDate,
  });
}
